import "./Style.scss";
import ImageGallery from "./ImageGallery";

export { ImageGallery };
